import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportNotificationService {
  private reportGeneratedSource = new Subject<void>();
  reportGenerated$ = this.reportGeneratedSource.asObservable();

  notifyReportGenerated() {
    this.reportGeneratedSource.next();
  }
}
